<article
  class="question-item"
  [class.question-item--expanded]="expanded()"
  [attr.aria-expanded]="expanded()"
>
  <button
    type="button"
    class="question-item__header"
    (click)="onHeaderClick()"
  >
    <span class="question-item__title t-14-600-primary">
      {{ headerText() }}
    </span>
    <img
      class="question-item__chevron"
      [src]="
        expanded()
          ? 'assets/icons/ic_angle_drop_up.svg'
          : 'assets/icons/ic_angle_drop_down.svg'
      "
      width="16"
      height="16"
      alt=""
      aria-hidden="true"
    />
  </button>

  @if (!expanded() && selectedOption()) {
    <p class="question-item__summary t-12-400-dark">
      @for (
        seg of optionDisplaySegments(selectedOption()?.description ?? '');
        track $index
      ) {
        @if (seg.emphasize) {
          <strong class="question-item__keyword">{{ seg.text }}</strong>
        } @else {
          {{ seg.text }}
        }
      }
    </p>
  }

  @if (expanded()) {
    <div class="question-item__body">
      <hr class="question-item__divider" />

      @if (detailParts().main) {
        <p class="question-item__detail t-12-400-dark">
          {{ detailParts().main }}
        </p>
      }

      @if (detailParts().bullets.length > 0) {
        <ul class="question-item__bullets t-12-400-dark">
          @for (bullet of detailParts().bullets; track $index) {
            <li>{{ bullet }}</li>
          }
        </ul>
      }

      <ul class="question-item__options" role="radiogroup">
        @for (option of question().options; track option.optionId) {
          <li class="question-item__option">
            <label class="question-item__radio-label">
              <input
                type="radio"
                class="question-item__radio"
                [name]="'q-' + question().questionId"
                [value]="option.optionId"
                [checked]="selectedOptionId() === option.optionId"
                (change)="onOptionSelect(option.optionId)"
              />
              <span class="question-item__radio-circle" aria-hidden="true"></span>
              <span class="question-item__radio-text t-12-400-dark">
                @for (
                  seg of optionDisplaySegments(option.description);
                  track $index
                ) {
                  @if (seg.emphasize) {
                    <strong class="question-item__keyword">{{ seg.text }}</strong>
                  } @else {
                    {{ seg.text }}
                  }
                }
              </span>
            </label>
          </li>
        }
      </ul>
    </div>
  }
</article>
